import React from "react";
import { GridItem } from "../common/GridItem";
import {
  Field,
  makeStyles,
  mergeClasses,
  Text,
  tokens,
  RadioGroup,
  Radio,
} from "@fluentui/react-components";
import { ChevronLeftFilled, ChevronRightFilled } from "@fluentui/react-icons";
import { UseFormReturn } from "react-hook-form";
import { ISignForm } from "../../interfaces/ISignForm";
import { useTranslation } from "react-i18next";
type SignAdditionsFormProps = {
  signForm: UseFormReturn<ISignForm, any, ISignForm>;
};
const useStyles = makeStyles({
  flex: {
    display: "flex",
  },
  fieldPopover: {
    display: "flex",
    alignItems: "center",
    "> label": {
      marginRight: tokens.spacingHorizontalL,
    },
  },
  dropdownLabel: {
    fontSize: tokens.fontSizeBase400,
    fontWeight: tokens.fontWeightSemibold,
  },
  counter: {
    display: "flex",
    alignItems: "center",
    "> strong": {
      marginLeft: tokens.spacingVerticalL,
      marginRight: tokens.spacingVerticalL,
      fontSize: tokens.fontSizeBase400,
    },
    "> svg": {
      cursor: "pointer",
    },
  },
  inputHeight: {
    height: tokens.spacingVerticalXXXL,
  },
  field: {
    fontWeight: tokens.fontWeightBold,
    marginTop: tokens.spacingVerticalL,
  },
  info: {
    width: "28px",
    height: "28px",
    cursor: "pointer",
  },
  fieldMargin: {
    marginLeft: tokens.spacingHorizontalXXL,
  },
  counterMargin: {
    marginTop: tokens.spacingHorizontalL,
  },
  breakRow: {
    gridColumnStart: "1",
  },
  marginTopInModal: {
    marginTop: tokens.spacingVerticalL,
  },
});
export const SignAdditionsForm = ({ signForm }: SignAdditionsFormProps) => {
  const styles = useStyles();
  const { t } = useTranslation();
  const { watch, setValue } = signForm;
  const sign = watch();
  const setQuantity = (increase: boolean, type: "quantity" | "mountTotal") => {
    const quantity = watch(type);
    if (increase) {
      setValue(type, quantity + 1);
    } else {
      quantity > 1 && setValue(type, quantity - 1);
    }
  };

  return (
    <>
      {/* <GridItem size="3/12">
        <div className={styles.fieldPopover}>
          <label className={styles.dropdownLabel}>{t("field.mount")}</label>

          <Popover>
            <PopoverTrigger disableButtonEnhancement>
              <InfoRegular className={styles.info} />
            </PopoverTrigger>
            <PopoverSurface>
              <MountPopOver />
            </PopoverSurface>
          </Popover>
        </div> */}
      {/* <Controller
          name={`poleDimension`}
          control={control}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <Field
              className={styles.field}
              size="medium"
              label={t("label.poleDimension")}
            >
              <Dropdown
                className={styles.inputHeight}
                value={
                  value
                    ? poleDimensionOptions().find((x) => x.value === value)
                        ?.text ?? ""
                    : ""
                }
                onOptionSelect={(e, d) => {
                  onChange(d.optionValue ? parseFloat(d.optionValue) : null);
                }}
              >
                {poleDimensionOptions().map((x) => (
                  <Option key={x.key} value={x.value.toString()}>
                    {x.text}
                  </Option>
                ))}
              </Dropdown>
            </Field>
          )}
        />
        <div className={styles.flex}>
          <Controller
            name={`mountingPoint`}
            control={control}
            rules={{ required: true }}
            render={({ field: { value, onChange }, fieldState: { error } }) => (
              <Field
                className={styles.field}
                size="medium"
                label={t("label.typeOfMount")}
                required
                validationState={error ? "error" : undefined}
                validationMessage={
                  error ? t("validation.mountingPoint") : undefined
                }
              >
                <Dropdown
                  className={styles.inputHeight}
                  value={
                    value
                      ? mountOptions().find((x) => x.value === value).text ??
                        null
                      : null
                  }
                  onOptionSelect={(e, d) => {
                    onChange(d.optionValue ? d.optionValue : "");
                  }}
                >
                  {mountOptions().map((x) => (
                    <Option key={x.key} value={x.value.toString()}>
                      {x.text}
                    </Option>
                  ))}
                </Dropdown>
              </Field>
            )}
          />
          <Field
            label={t("label.amountOfClamps")}
            className={mergeClasses(styles.field, styles.fieldMargin)}
            size="medium"
          >
            <div className={styles.counter}>
              <ChevronLeftFilled
                fontSize={24}
                onClick={() => setQuantity(false, "mountTotal")}
              />
              <Text as="strong">{sign.mountTotal}</Text>
              <ChevronRightFilled
                fontSize={24}
                onClick={() => setQuantity(true, "mountTotal")}
              />
            </div>
          </Field>
        </div>
      </GridItem>*/}
      <GridItem size="4/12" className={styles.breakRow}>
        <Field
          label={t("field.graffitiProtection")}
          className={mergeClasses(styles.field, styles.marginTopInModal)}
          size={"large"}
        >
          <RadioGroup
            value={sign.graffitiProtection ? "true" : "false"}
            onChange={(_, data) =>
              setValue(
                "graffitiProtection" as any,
                data.value === "true" ? true : false
              )
            }
            layout="horizontal"
          >
            <Radio value="true" label="Ja" />
            <Radio value="false" label="Nej" />
          </RadioGroup>
        </Field>
        {/* <div className={styles.flex}>
            <BadgeSelect
              signForm={signForm}
              label={t("field.graffitiProtection")}
              firstChoice={t("badge.yes")}
              secondChoice={t("badge.no")}
              type={"graffitiProtection"}
              modalView
              labelSize="medium"
            />

            <BadgeSelect
              signForm={signForm}
              label={t("field.needsMounting")}
              firstChoice={t("badge.yes")}
              secondChoice={t("badge.no")}
              type={"needsMounting"}
              modalView
              labelSize="medium"
            />
          </div> */}
      </GridItem>
      <GridItem size="12/12">
        <Field label={t("field.amountOfSigns")} size="large">
          <div className={mergeClasses(styles.counter, styles.counterMargin)}>
            <ChevronLeftFilled
              fontSize={24}
              onClick={() => setQuantity(false, "quantity")}
            />
            <Text as="strong">{sign.quantity}</Text>
            <ChevronRightFilled
              fontSize={24}
              onClick={() => setQuantity(true, "quantity")}
            />
          </div>
        </Field>
      </GridItem>
    </>
  );
};
